import actionTypes from '../actions/actionTypes'
import { gtmPushMetric } from 'helpers/social'

function getOnboardingStepChangeEvent(action) {
	//This validation is because change step gets called repeatedly
	if (!action.isNewStep) {
		return ''
	}
	let base_event_name = actionTypes.ONBOARDING_CHANGE_STEP
	base_event_name += '/' + action.step
	if (action.fromNumberButton) {
		base_event_name += '/FROM_NUMBER'
	}
	if (action.fromStore) {
		base_event_name += '/FROM_STORE'
	}
	return base_event_name
}
function getOnboardingSkipEvent(action) {
	let base_event_name = actionTypes.ONBOARDING_SKIP
	if (action.fromStore) {
		base_event_name += '/FROM_STORE'
	}
	base_event_name += '/' + action.step
	return base_event_name
}
function getOnboardingSelectLessonEvent(action) {
	let base_event_name = actionTypes.ONBOARDING_LESSON_SELECTED
	if (!action._added) {
		base_event_name = ''
	}
	return base_event_name
}

function getEventName(action) {
	switch (action.type) {
		case actionTypes.ONBOARDING_CHANGE_STEP:
			return getOnboardingStepChangeEvent(action)
			break
		case actionTypes.ONBOARDING_SKIP:
			return getOnboardingSkipEvent(action)
			break
		case actionTypes.ONBOARDING_LESSON_SELECTED:
			return getOnboardingSelectLessonEvent(action)
			break
	}
	return action.type

}

function validateField(actionType, field) {
	if (field === 'type') {
		return false
	} else if (
		[
			'@@redux-form/CHANGE',
			'@@redux-form/BLUR',
			'@@redux-form/TOUCH',
			'@@redux-form/SET_SUBMIT_FAILED',
			'@@redux-form/UPDATE_SYNC_ERRORS',
			'@@redux-form/FOCUS',
		].includes(actionType)) {
		return false
	} else if (
		[
			actionTypes.LOGIN_SEND_FORM,
			actionTypes.SIGNUP_SEND_EMAIL_FORM,
			actionTypes.LOGIN_SEND_FORGOT_PASSWORD_FORM,
			actionTypes.LOGIN_SEND_NEW_PASSWORD_FORM,
			actionTypes.SIGNUP_TEACHER_EMAIL_ALREADY_REGISTERED,
			actionTypes.LOGIN_STUDENT_GOOGLE_LOGIN_SUCCESS,
			actionTypes.LOGIN_STUDENT_SUBMIT_LOGIN_GOOGLE_TOKEN_SUCCESS,
			actionTypes.LOGIN_STUDENT_OFFICE_365_LOGIN_SUCCESS,
			actionTypes.LOGIN_STUDENT_SUBMIT_LOGIN_OFFICE_365_TOKEN_SUCCESS,
			actionTypes.STUDENT_INITIALIZE_LEAD_WITH_DATA,
			actionTypes.STUDENT_LEAD_FIELD_CHANGE,
			actionTypes.STUDENT_LEAD_GOOGLE_LOGIN_SUCCESS,
			actionTypes.STUDENT_SUBMIT_LEAD_GOOGLE_TOKEN_SUCCESS,
			actionTypes.STUDENT_LEAD_OFFICE_365_LOGIN_SUCCESS,
			actionTypes.STUDENT_SUBMIT_LEAD_OFFICE_365_TOKEN_SUCCESS,
			actionTypes.STUDENT_LEAD_GOOGLE_GET_NAME_SUCCESS,
			actionTypes.STUDENT_LEAD_OFFICE_365_GET_NAME_SUCCESS,
		].includes(actionType)) {
		return false
	}
	return true
}

function formatPayload(action) {
	const keys = Object.keys(action)
	return keys.reduce(function(acc, value) {
		if (validateField(action.type, value)) {
			acc[value] = action[value]
		}

		return acc
	}, {})
}

window.dataLayer = window.dataLayer || []

const metricsMiddleware = function() {
	return function(next) {
		return function(action) {
			next(action)
			const payload = formatPayload(action)
			const event_name = getEventName(action)
			gtmPushMetric(event_name, payload)
		}
	}
}

export default metricsMiddleware
